module.exports = __webpack_public_path__ + "static/img/20013 (1).e7cf37a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20013 (1).webp
// module id = stmN
// module chunks = 14